import './index.less'

export default () => {
    gsap.registerPlugin(ScrollTrigger);
    const isMobile = window.innerWidth <= 1024
    if(isMobile) {
        const scrollContentObserve = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    document.querySelectorAll(".sec-content--mb .sec-content--main .content .cont>p").forEach((item, index) => {
                        setTimeout(() => {
                            item.classList.add("show")
                        }, index * 80);
                    })
                }
            }, {threshold: 0.4});
        });

        scrollContentObserve.observe(document.querySelector(".sec-content--mb .sec-content--main .content .cont>p"))
    }

    if (!isMobile) {
        // 文字
        document.querySelectorAll('.jky-ces-animate .theme-item').forEach((item, index) => {
            gsap.to(item, {
                scrollTrigger: {
                    trigger: document.querySelectorAll(".trigger-ele")[index],
                    toggleActions: "play play reverse reverse",
                    // markers: true,
                    start: `top ${window.innerHeight - 240}`,
                    end: `bottom ${window.innerHeight - 240}`,
                    onLeave: function (self) {
                        item.classList.remove("show")
                        item.classList.add("hide")

                        if(index === document.querySelectorAll('.jky-ces-animate .theme-item').length - 1) {
                            item.classList.remove("hide")
                            item.classList.add("show")
                        }
                    },
                    onLeaveBack: function(self) {
                        if(index === 0) {
                            item.classList.remove("hide")
                            item.classList.add("show")
                        }
                    },
                    onToggle: function (self) {
                        if (self.isActive) {
                            item.classList.remove("hide")
                            item.classList.add("show")
                        } else {
                            item.classList.remove("show")
                            item.classList.remove("hide")
                        }
                    }
                },
            })
        })
    }
}